// 设置项，其他模块可能会应用，在此导出
export enum SettingTab {
  USER_CENTER = 'userCenter', // 个人设置 仅web端 PC端
  SYSTEM = 'system', // 系统设置 仅PC端
  UPLOAD = 'upload', // 上传设置 仅PC端
  DOWNLOAD = 'download', // 下载设置 仅PC端
  NOTIFICATIONS = 'notifications', // 消息设置 仅PC端
  PROXY = 'proxy', // 代理设置 仅PC端
  SECURITY = 'security', // 安全设置 仅PC端
  INTERNAL_SERVER = 'internalServer', // 私有化设置 仅PC端
  LANGUAGE = 'language', // 语言设置 仅web端 PC端
}
